export default {"src":"/_next/static/media/zenadmin-double-border.fe066ea9.svg","height":86,"width":86,"blurWidth":0,"blurHeight":0};